import(/* webpackMode: "eager" */ "/runner/_work/get-serious/get-serious/frontend/src/app/not-found.tsx");
